import { useContext, useEffect, useState } from 'react';

import styles from './ConfHeaderComponent.module.css'

import { GlobalContext } from "../../contexts/globalContext";

import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import CurrentParticipantVideoComponent from './CurrentParticipantVideoComponent';

import animationLive from '../../graphics/conferenceScreen/anim-LIVE.json'

import Lottie from 'react-lottie-player';

const ConfHeaderComponent = () => {

    const {
        currentConference, currentTopic, currentParticipant, currentParticipantStream, socketRef, setSeeQrCode, seeQrCode,
        setOpenEditProfile, localSocketRef
    } = useContext(GlobalContext);

    const [background, setBackground] = useState();
    const [showVideo, setShowVideo] = useState(false);
    const [moderatorList, setModeratorList] = useState([]);

    useEffect(() => {
        if (currentConference.type === "Presentation") {
            if (currentParticipant?._id === currentConference.moderatedBy || showVideo) {
                setBackground("#171132")
            } else {
                setBackground("transparent");
            }
        } else {
            if (currentParticipant?._id === currentTopic?.moderator._id) {
                setBackground("#EEEEEE");
            } else {
                setBackground("#171132");
            }
        }

    }, [showVideo, currentTopic])

    useEffect(() => {
        if (currentConference.videoPaused) {
            setShowVideo(false);
        } else {
            setShowVideo(true);
        }

        const playVideosListener = function (conferenceId) {
            if (conferenceId === currentConference._id) {
                if (localSocketRef.current?.connected) {
                    localSocketRef.current.emit("serial:cameraUp");
                }
                setShowVideo(true);
            }
        };

        const pauseVideosListener = function (conferenceId) {
            if (conferenceId === currentConference._id) {
                if (localSocketRef.current?.connected) {
                    localSocketRef.current.emit("serial:cameraDown");
                }
                setShowVideo(false);
            }
        };

        socketRef.current.on('PLAY_VIDEOS', playVideosListener);
        socketRef.current.on('PAUSE_VIDEOS', pauseVideosListener);

        return () => {
            socketRef.current?.off('PLAY_VIDEOS', playVideosListener);
            socketRef.current?.off('PAUSE_VIDEOS', pauseVideosListener);
        }
    }, [])

    useEffect(() => {
        let modArray = []

        for (let i = 0; i < currentConference.topics.length; i++) {
            let modId = currentConference.topics[i].moderator._id
            if (!modArray.includes(modId)) {
                modArray.push(currentConference.topics[i].moderator._id)
            }
        }

        setModeratorList(modArray)

    }, [currentConference])

    // useEffect(() => {
    //     const checkScroll = () => {
    //         if (nameRef.current) {
    //             const containerWidth = nameRef.current.offsetWidth;
    //             const textWidth = nameRef.current.scrollWidth;
    //             setIsScrollable(textWidth > containerWidth);
    //         }
    //     };

    //     setTimeout(checkScroll, 0); // Ensure it runs after the component mounts

    //     window.addEventListener("resize", checkScroll); // Update on resize
    //     return () => window.removeEventListener("resize", checkScroll);
    // }, [currentParticipant?.name]);

    const onClickQrCode = () => {
        if (currentParticipant?.telephone && currentParticipant?.organization) {
            setSeeQrCode(!seeQrCode)
        } else {
            setOpenEditProfile(true)
        }

    }

    function getGreetingMessage() {
        const now = new Date();
        const hour = now.getHours();

        if (hour >= 0 && hour < 4) {
            return 'Good night';
        } else if (hour >= 4 && hour < 12) {
            return 'Good morning';
        } else if (hour >= 12 && hour < 18) {
            return 'Good afternoon';
        } else {
            return 'Good evening';
        }
    }

    return (
        <div style={{
            display: "flex", zIndex: 1,
            alignItems: "center",
            transition: "all 0.3s",
            justifyContent: (currentConference.type === "Presentation" && currentConference.moderatedBy !== currentParticipant?._id && showVideo) ? "center" : "start",
            flexDirection: (currentConference.type === "Presentation" && currentConference.moderatedBy !== currentParticipant?._id && showVideo) ? "column" : "row",
            position: "relative",
            width: "900px",
            height: (currentConference.type === "Presentation" && currentConference.moderatedBy !== currentParticipant?._id && showVideo) ? "600px" : "190px",
            background: currentConference.type === "Presentation" && currentParticipant?._id === currentConference.moderatedBy && !currentConference.paused && currentConference.status === "Active"
                ? "#EEEEEE" : background,
            borderRadius: "0px 0px 10px 10px",
            marginBottom: "10px"
        }}>

            {currentParticipantStream && <CurrentParticipantVideoComponent />}

            <div style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: (currentConference.type === "Presentation" && currentConference.moderatedBy !== currentParticipant?._id && showVideo) ? "center" : "start",
                padding: "20px 30px"
            }}>
                <div style={{
                    font: "normal normal normal 28px/42px Bio Sans",
                    color: (currentConference.type === "Presentation" && currentConference.moderatedBy !== currentParticipant?._id && showVideo) ? "#EEEEEE" :
                        (currentConference.type === "Presentation" && currentParticipant?._id === currentConference.moderatedBy && !currentConference.paused && currentConference.status === "Active")
                            ? "#050020" : "#726FA8",
                    marginBottom: (currentConference.type === "Presentation" && currentConference.moderatedBy !== currentParticipant?._id && showVideo) ? 4 : 0
                }}>
                    {getGreetingMessage()}
                </div>
                <div style={{
                    font: "normal normal 600 50px/60px Bio Sans",
                    color: (currentParticipant?._id === currentTopic?.moderator._id && currentConference.type !== "Presentation") ||
                        (currentConference.type === "Presentation" && currentParticipant?._id === currentConference.moderatedBy && !currentConference.paused &&
                            currentConference.status === "Active") ? "#050020" :
                        (currentConference.type === "Presentation" && currentConference.moderatedBy !== currentParticipant?._id && showVideo) ? "white" : "#726FA8",
                    maxWidth: ((currentConference.type === "Presentation" && currentParticipant?._id === currentConference.moderatedBy) || (currentConference.type === "Conference"
                        && currentTopic?.moderator._id === currentParticipant?._id)) && !currentConference.paused && currentConference.status === "Active" ? 500 : 580,
                    whiteSpace: currentConference.moderatedBy === currentParticipant?._id && currentConference.type === "Presentation" ? "nowrap" : "",
                    overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                    textAlign: currentConference.moderatedBy === currentParticipant?._id && currentConference.type === "Presentation" ? "start" : "center"
                }}>
                    {currentParticipant?.name}
                </div>
                <div style={{ font: "normal normal normal 28px/28px Bio Sans", color: "#726FA8" }}>{currentParticipant?.entitle}</div>
            </div>
            {(currentConference.moderatedBy === currentParticipant?._id || moderatorList.includes(currentParticipant?._id)) && currentConference.type !== "Meeting" &&
                <div style={{
                    width: 67, height: 145, borderRadius: 8,
                    background: ((currentConference.type === "Presentation" && currentParticipant?._id === currentConference.moderatedBy) || (currentConference.type === "Conference"
                        && currentTopic?.moderator._id === currentParticipant?._id)) && !currentConference.paused && currentConference.status === "Active" ?
                        "#FFFFFF 0% 0% no-repeat padding-box" : "#332D57 0% 0% no-repeat padding-box",
                    color: "#726FA8", fontSize: 40, alignItems: "center", display: "flex", flexDirection: "column", justifyContent: "center", position: "absolute",
                    right: ((currentConference.type === "Presentation" && currentParticipant?._id === currentConference.moderatedBy) || currentConference.type === "Conference") &&
                        !currentConference.paused && currentConference.status === "Active" && !currentConference.discussionOpened ? 120 : 30
                }} onClick={onClickQrCode}>
                    <FontAwesomeIcon icon={byPrefixAndName.fal['qrcode']} />
                </div>
            }
            {((currentConference.type === "Presentation" && currentParticipant?._id === currentConference.moderatedBy) || (currentConference.type === "Conference"
                && currentTopic?.moderator._id === currentParticipant?._id)) && !currentConference.paused && currentConference.status === "Active" &&
                <div className={styles.live}>
                    <Lottie
                        loop={true}
                        play={true}
                        animationData={animationLive}
                        style={{ width: 50, height: 50, position: "relative" }}
                    />
                    LIVE
                </div>}
        </div>
    );
}

export default ConfHeaderComponent;